<template>
  	<div>
		<div class="top-card-box">
				<span class="top_title">Hello, 开始一天的工作吧!</span>
				
			</div>

		<div class="quick-access">
			<div class="quick-access-title">
				<span>快捷入口</span>
			</div>
				
			<div>
				<el-row :gutter="20" style="text-align: center; padding: 30px 20px; box-sizing: border-box;">
				
					<el-col :span="4">
						<div class="quick-access-col" @click="goPage('/shop_list')">
							<div class="quick-access-icon" style="background-color: rgba(255, 156, 110, 0.3);">
								<i class="el-icon-office-building" style="color: rgb(255, 156, 110);"> 
								</i>
							</div>
							<p>店铺管理</p>
						</div>
					</el-col>
					
					<el-col :span="4">
						<div class="quick-access-col" @click="goPage('/room_list')">
							<div class="quick-access-icon" style="background-color: rgba(105, 192, 255, 0.3);">
								<i class="el-icon-house" style="color: rgb(105, 192, 255);"> 
								</i>
							</div>
							<p>包间管理</p>
						</div>
					</el-col>
					
					<el-col :span="4">
						<div class="quick-access-col" @click="goPage('/banner_system')">
							<div class="quick-access-icon" style="background-color: rgba(179, 127, 235, 0.3);">
								<i class="el-icon-copy-document" style="color: rgb(179, 127, 235);"> 
								</i>
							</div>
							<p>广告管理</p>
						</div>
					</el-col>
					
					<el-col :span="4">
						<div class="quick-access-col" @click="goPage('/settled_system')">
							<div class="quick-access-icon" style="background-color: rgba(255, 214, 102, 0.3);">
								<i class="el-icon-magic-stick" style="color: rgb(255, 214, 102);"> 
								</i>
							</div>
							<p>加盟管理</p>
						</div>
					</el-col>
					
					<el-col :span="4">
						<div class="quick-access-col" @click="goPage('/user_system')">
							<div class="quick-access-icon" style="background-color: rgba(255, 133, 192, 0.3);">
								<i class="el-icon-user" style="color: rgb(255, 133, 192);"> 
								</i>
							</div>
							<p>角色管理</p>
						</div>
					</el-col>
					
					<el-col :span="4">
						<div class="quick-access-col" @click="goPage('/device_system')">
							<div class="quick-access-icon" style="background-color: rgba(92, 219, 211, 0.3);">
								<i class="el-icon-cpu" style="color: rgb(92, 219, 211);"> 
								</i>
							</div>
							<p>设备管理</p>
						</div>
					</el-col>
				</el-row>
			</div>

				
		</div>

		<div class="quick-access">
			<div class="quick-access-title">
				<span>数据报表</span>
			</div>


			
			<div>
				<el-row style="margin-top: 20px;">
					<el-col :span="8">
						<div>
							<div id='shopEchartsId' style="height: 500px;"></div>
						</div>
					</el-col>
					
					<el-col :span="8">
						<div>
							<div id='roomEchartsId' style="height: 500px;"></div>
						</div>
					</el-col>

					<el-col :span="8">
						<div>
							<div id='deviceEchartsId' style="height: 500px;"></div>
						</div>
					</el-col>
				</el-row>
			</div>

		</div>
  	</div>
</template>


<script>

export default {
	name:"home",
	
	data() {
		return {

		}

	},

 

	mounted() {
		this.initEcharts()

	},

	methods: {
		// 跳转界面接口
		goPage(page) {
			this.$router.push(page);
		},

		// 获取当前天气
		getWeather() {
			
		},

		// 实例化echarts
		async initEcharts() {
			// 店铺
			let shopEcharts = this.$echarts.init(document.getElementById('shopEchartsId'))
			let shopOption = await this.getShopInfo()
			console.log(shopOption)
			shopEcharts.setOption(shopOption)

			// 包间
			let roomEcharts = this.$echarts.init(document.getElementById('roomEchartsId'))
			let roomOption = await this.getRoomInfo()
			roomEcharts.setOption(roomOption)

			// 设备统计
			let deviceEcharts = this.$echarts.init(document.getElementById('deviceEchartsId'))
			let deviceOption = await this.getDeviceInfo()
			deviceEcharts.setOption(deviceOption)
		},

		// 获取设备信息
		async getDeviceInfo() {
			let res = await this.$axios.get('/api/device/')
			let data = res.data
			let deviceOption = {}
			deviceOption.title = {
				text: '设备统计',
				left: 'center',
				top: 'center'
			}

			deviceOption.series = []

			// 统计设备类型
			let deviceType = {
				'门锁': 0,
				'空调': 0,
				'断路器': 0,
			}

			data.forEach(item => {
				if (item.device_type == 0) {
					deviceType['门锁']++
				} else if (item.device_type == 2) {
					deviceType['空调']++
				} else if (item.device_type == 1) {
					deviceType['断路器']++
				}
			})

			deviceOption.series.push({
				type: 'pie',
				data: [
					{
						name: '门锁' + deviceType['门锁'] + '个',
						value: deviceType['门锁']
					},
					{
						name: '空调' + deviceType['空调'] + '个' ,
						value: deviceType['空调']
					},
					{
						name: '断路器' + deviceType['断路器'] + '个',
						value: deviceType['断路器']
					}
				],
				radius: ['40%', '70%']
			})

			return deviceOption

		},

		// 请求包间信息
		async getRoomInfo() {
			let res = await this.$axios.get('/api/rooms/')
			let data = res.data
			let roomOption = {}
			roomOption.title = {
				text: '包间使用情况',
				left: 'center',
				top: 'center'
			}

			roomOption.series = []

			// 获取包间状态信息
			let roomStatus = {
				'空闲中': 0,
				'使用中': 0,
				'锁定中': 0,
				'待打扫': 0,
				'待维修': 0,
				'更改玩法': 0,

			}
			data.forEach(item => {
				if (item.room_status == 0){
					// 空闲
					roomStatus['空闲中'] += 1 
				}
				if (item.room_status == 1){
					// 使用中
					roomStatus['使用中'] += 1 
				}
				if (item.room_status == 2){
					// 锁定中
					roomStatus['锁定中'] += 1 
				}
				if (item.room_status == 3){
					// 待打扫
					roomStatus['待打扫'] += 1 
				}
				if (item.room_status == 4){
					// 待维修
					roomStatus['待维修'] += 1 
				}
				if (item.room_status == 5){
					// 更改玩法
					roomStatus['更改玩法'] += 1 
				}
			})

			roomOption.series.push({
				type: 'pie',
				data: [
					{
						"name": "空闲中" + roomStatus['空闲中'] + '个',
						"value": roomStatus['空闲中']
					},
					{
						"name": "使用中" + roomStatus['使用中'] + '个',
						"value": roomStatus['使用中']
					},
					{
						"name": "锁定中" + roomStatus['锁定中'] + '个',
						"value": roomStatus['锁定中']
					},
					{
						"name": "待打扫" + roomStatus['待打扫'] + '个',
						"value": roomStatus['待打扫']
					},
					{
						"name": "待维修" + roomStatus['待维修'] + '个',
						"value": roomStatus['待维修']
					},
					{
						"name": "更改玩法" + roomStatus['更改玩法'] + '个',
						"value": roomStatus['更改玩法']
					}
				],
				radius: ['40%', '70%']
			
			})

			return roomOption

		},

		// 请求店铺信息
		async getShopInfo() {
			let res = await this.$axios.get('/api/shops/')
			let data = res.data
			// 处理数据
			let shopOption = {}
			shopOption.title = {
				text: '店铺情况开业情况',
				left: 'center',
				top: 'center'
			}

			shopOption.series = []

			// 获取店铺开启关闭情况
			let openShop = 0
			let closeShop = 0
			data.forEach(item => {
				if (item.is_use == 1) {
					openShop++
				} else {
					closeShop++
				}
			})

			shopOption.series.push({
				type: 'pie',
				data: [
					{
					value: openShop,
					name: '开启' + openShop + "个"
					},
					{
					},
					{
					value: closeShop,
					name: '关闭' + closeShop + "个"
					}
				],
				radius: ['40%', '70%']
			})

			return shopOption
		}
	}
}
</script>

<style>

.data-card-box {
	padding: 12px 16px;
	background-color: #fff;
	border-left: 16px solid #e4e7ed;
	border-right: 16px solid #e4e7ed;
	border-bottom: 12px solid #e4e7ed;
}
	
.top-card-box {
	padding: 12px 16px;
	font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","\5fae\8f6f\96c5\9ed1",Arial,sans-serif;
	/* border:8px solid #e4e7ed; */
	background-color: #fff;
	border-top: 12px solid #e4e7ed;
	border-left: 16px solid #e4e7ed;
	border-right: 16px solid #e4e7ed;
	border-bottom: 12px solid #e4e7ed;
	height: 100%;
}
.top_title {
	font-size: 22px;
}

.quick-access {
	padding: 12px 16px;
	background-color: #fff;
	/* border-top: 12px solid #e4e7ed; */
	border-left: 16px solid #e4e7ed;
	border-right: 16px solid #e4e7ed;
	border-bottom: 12px solid #e4e7ed;
}

.quick-access-title {
	padding-bottom: 20px;
	border-bottom: 1px solid #e8e8e8;
}

.quick-access-col {
	padding: 16px 28px;
	margin-top: -16px;
	margin-bottom: -16px;
	border-radius: 4px;
	transition: all .2s;
	cursor: pointer;
	height: auto;
	text-align: center;
	box-shadow: none;
	box-sizing: border-box
}



.quick-access-col p {
	margin-top: 15px;
	box-sizing:inherit;
	
}

.quick-access-col i {
	font-size: 24px;
	box-sizing:inherit
}

/* 鼠标悬停 修改背景色 */
.quick-access-col:hover {
	background-color: #f5f7fa;
	box-shadow: 0 0 8px rgba(0,0,0,.1);
}


.quick-access-icon {
	width: 50px;
	height: 50px!important;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
}

/* div 居中 */
.div-echarts-tag {
	display: flex;
	align-items: center;
	justify-content: center;
}


</style>
